/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetLanguageVersionsForMenuDocument = gql`
    query GetLanguageVersionsForMenu($companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      languages {
        id
        name
        isoCode
      }
      primaryLanguage {
        id
        name
        isoCode
      }
    }
  }
}
    `;

/**
 * __useGetLanguageVersionsForMenuQuery__
 *
 * To run a query within a React component, call `useGetLanguageVersionsForMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguageVersionsForMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguageVersionsForMenuQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetLanguageVersionsForMenuQuery(baseOptions: Apollo.QueryHookOptions<GetLanguageVersionsForMenuQuery, GetLanguageVersionsForMenuQueryVariables> & ({ variables: GetLanguageVersionsForMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguageVersionsForMenuQuery, GetLanguageVersionsForMenuQueryVariables>(GetLanguageVersionsForMenuDocument, options);
      }
export function useGetLanguageVersionsForMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguageVersionsForMenuQuery, GetLanguageVersionsForMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguageVersionsForMenuQuery, GetLanguageVersionsForMenuQueryVariables>(GetLanguageVersionsForMenuDocument, options);
        }
export function useGetLanguageVersionsForMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLanguageVersionsForMenuQuery, GetLanguageVersionsForMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLanguageVersionsForMenuQuery, GetLanguageVersionsForMenuQueryVariables>(GetLanguageVersionsForMenuDocument, options);
        }
export type GetLanguageVersionsForMenuQueryHookResult = ReturnType<typeof useGetLanguageVersionsForMenuQuery>;
export type GetLanguageVersionsForMenuLazyQueryHookResult = ReturnType<typeof useGetLanguageVersionsForMenuLazyQuery>;
export type GetLanguageVersionsForMenuSuspenseQueryHookResult = ReturnType<typeof useGetLanguageVersionsForMenuSuspenseQuery>;
export type GetLanguageVersionsForMenuQueryResult = Apollo.QueryResult<GetLanguageVersionsForMenuQuery, GetLanguageVersionsForMenuQueryVariables>;
export const GetLanguageVersionsForMenuFillingDocument = gql`
    query GetLanguageVersionsForMenuFilling($companyId: Int!, $branchId: Int, $menuId: Int) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branches(id: $branchId) {
        menusList(id: $menuId) {
          languages {
            id
            name
            isoCode
          }
          primaryLanguage {
            id
            name
            isoCode
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetLanguageVersionsForMenuFillingQuery__
 *
 * To run a query within a React component, call `useGetLanguageVersionsForMenuFillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguageVersionsForMenuFillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguageVersionsForMenuFillingQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      menuId: // value for 'menuId'
 *   },
 * });
 */
export function useGetLanguageVersionsForMenuFillingQuery(baseOptions: Apollo.QueryHookOptions<GetLanguageVersionsForMenuFillingQuery, GetLanguageVersionsForMenuFillingQueryVariables> & ({ variables: GetLanguageVersionsForMenuFillingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguageVersionsForMenuFillingQuery, GetLanguageVersionsForMenuFillingQueryVariables>(GetLanguageVersionsForMenuFillingDocument, options);
      }
export function useGetLanguageVersionsForMenuFillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguageVersionsForMenuFillingQuery, GetLanguageVersionsForMenuFillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguageVersionsForMenuFillingQuery, GetLanguageVersionsForMenuFillingQueryVariables>(GetLanguageVersionsForMenuFillingDocument, options);
        }
export function useGetLanguageVersionsForMenuFillingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLanguageVersionsForMenuFillingQuery, GetLanguageVersionsForMenuFillingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLanguageVersionsForMenuFillingQuery, GetLanguageVersionsForMenuFillingQueryVariables>(GetLanguageVersionsForMenuFillingDocument, options);
        }
export type GetLanguageVersionsForMenuFillingQueryHookResult = ReturnType<typeof useGetLanguageVersionsForMenuFillingQuery>;
export type GetLanguageVersionsForMenuFillingLazyQueryHookResult = ReturnType<typeof useGetLanguageVersionsForMenuFillingLazyQuery>;
export type GetLanguageVersionsForMenuFillingSuspenseQueryHookResult = ReturnType<typeof useGetLanguageVersionsForMenuFillingSuspenseQuery>;
export type GetLanguageVersionsForMenuFillingQueryResult = Apollo.QueryResult<GetLanguageVersionsForMenuFillingQuery, GetLanguageVersionsForMenuFillingQueryVariables>;
export type GetLanguageVersionsForMenuQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetLanguageVersionsForMenuQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string, isoCode: string }> | null, primaryLanguage?: { __typename?: 'LanguageProxy', id: number, name: string, isoCode: string } | null } | null } | null };

export type GetLanguageVersionsForMenuFillingQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetLanguageVersionsForMenuFillingQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', menusList?: Array<{ __typename?: 'MenuProxy', languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string, isoCode: string }> | null, primaryLanguage?: { __typename?: 'LanguageProxy', id: number, name: string, isoCode: string } | null }> | null }> | null } | null } | null };
